import { render } from "./RotateClockwise.vue?vue&type=template&id=dbeea6ca"
import script from "./RotateClockwise.vue?vue&type=script&lang=js"
export * from "./RotateClockwise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__